// TRANSLATIONS
import axios from 'axios';

import global from '@/store/global';

import { i18n } from '../main';

// page load setup
// keep track of already loaded languages
const loadedLangs: string[] = [];

// LOAD LANGUAGE EXPORT
export function loadLanguage(lang: string = 'sk') {
  // helper for page lang setup
  function _setPageStuffLang(pLang: string) {
    i18n.global.locale.value = pLang;
    global.language = lang;
    axios.defaults.headers.common['Accept-Language'] = pLang;
    document.querySelector('html')?.setAttribute('lang', pLang);
  }

  // if we have that language already, switch it
  if (loadedLangs.includes(lang)) {
    _setPageStuffLang(lang);
  }

  // load the language if we dont have it yet
  import(`@/translations/langs/${lang}.json`)
    .then((msg) => {
      i18n.global.setLocaleMessage(
        lang,
        JSON.parse(JSON.stringify(msg.default)),
      );
      loadedLangs.push(lang);
      _setPageStuffLang(lang);
    })
    .catch((e) => {
      console.warn(e);
    });
}
